import * as XLSX from 'xlsx'

export function exportToExcel(
  fileName: string,
  data: Array<any>,
  columnSetting: {
    headerNames: Array<string>
    columnWidths?: Array<number>
    widthDefault?: number
  }
) {
  const worksheet = XLSX.utils.json_to_sheet(data)

  // Modify the column header names
  const header = columnSetting?.headerNames.map((name, index) => ({
    v: name,
    position: String.fromCharCode(65 + index) + 1
  }))
  const headers = header.reduce((acc: any, curr: any) => {
    acc[curr.position] = {
      v: curr.v,
      s: {
        font: { bold: true },
        fill: {
          patternType: 'solid',
          fgColor: { rgb: 'FF939393' }
        },
        height: 40
      }
    }
    return acc
  }, {})

  // Append the modified header to the worksheet
  worksheet['!ref'] = XLSX.utils.encode_range(
    XLSX.utils.decode_range(worksheet['!ref'] as string)
  )
  Object.assign(worksheet, headers)

  // Set the width of a specific column
  const columnWidths = columnSetting?.columnWidths
    ? columnSetting?.columnWidths?.map((width) => {
        return { wch: width }
      })
    : columnSetting?.headerNames?.map(() => {
        return { wch: columnSetting?.widthDefault || 20 } // Default column width of 20
      })
  worksheet['!cols'] = columnWidths

  // Set alignment to left for all cells
  const range = XLSX.utils.decode_range(worksheet['!ref'] as string)
  for (let rowNum = range.s.r + 1; rowNum <= range.e.r; rowNum++) {
    for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
      const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum })
      if (!worksheet[cellAddress]) {
        continue
      }
      const cell = worksheet[cellAddress]
      if (!cell.s) {
        cell.s = {}
      }
      cell.s.alignment = {
        vertical: 'bottom',
        horizontal: 'left',
        wrap_text: true
      }
    }
  }

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  const dataBlob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  const url = URL.createObjectURL(dataBlob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${fileName}.xlsx`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
